import React from 'react'
import classNames from './index.scss'
import '@yaireo/tagify/dist/tagify.css'
import config from 'config'
import WebAppIframe from '../../../components/WebAppIframe'

class SocialMediaRewardDefinitionIframe extends React.Component {
  render() {
    const url = new URL(window.location.href)
    const authCode = url.searchParams.get('code')
    return (
      <div style={{width: '100%', margin: '0 auto'}}>
        <WebAppIframe
          src={`${config.casaWebAppUrl}/social-media/create/?code=${authCode}`}
          id="iframe"
          className={`${classNames.iframe}`}
        />
      </div>
    )
  }
}

export default SocialMediaRewardDefinitionIframe




// WEBPACK FOOTER //
// ./src/routes/SocialMediaReward/containers/index.js